import React from 'react';
import { StyledForm, StyledSearchField, SearchButton, StyledCloseIcon } from './Search.styles.mjs';
import { useTheme } from 'styled-components';

const Search = ({ onSearch, onClose, className, testId }) => {
    const theme = useTheme();
    const handleClose = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    return (React.createElement(StyledForm, { onSubmit: onSearch, "data-testid": testId, className: className },
        React.createElement(StyledSearchField, { name: "search", type: "text", placeholder: "Search News12" }),
        React.createElement(SearchButton, { iconType: "search", ariaLabel: "Submit search", color: theme.colors.searchBarIconColor }),
        onClose && (React.createElement(StyledCloseIcon, { type: "button", onClick: handleClose, "aria-label": "Close search" },
            React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M18 6L6 18M6 6L18 18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))))));
};

export { Search as default };
//# sourceMappingURL=Search.mjs.map
